module.exports = __webpack_public_path__ + "img/logo_with.00a4d035.png";